module.exports = __webpack_public_path__ + "img/1b9a93adfdcb6d718fbee06deaeaa5e5.png";